import { render } from "./ClassComment.vue?vue&type=template&id=08b1a35b&scoped=true"
import script from "./ClassComment.vue?vue&type=script&lang=ts"
export * from "./ClassComment.vue?vue&type=script&lang=ts"

import "./ClassComment.vue?vue&type=style&index=0&id=08b1a35b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-08b1a35b"

export default script